module.exports = __webpack_public_path__ + "img/chat_bookmark_inactive.3697f8ff.svg";